import { useState, useCallback } from 'react';
import quarkusApi from '../../api/quarkusApi';

export function useSaveIncome() {
  const [isSaving, setSaving] = useState(false);

  const save = useCallback((income) => {
    setSaving(true);
    const authHeader = { headers: { Authorization: sessionStorage.getItem('token') } };
    const request = income.id
      ? quarkusApi.put('/financial/incomes', income, authHeader)
      : quarkusApi.post('/financial/incomes', income, authHeader);
    return request.finally(() => setSaving(false));
  }, []);

  return { save, isSaving };
}
